import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/v2/buttons/Button';
import CargomaticModal from 'components/v2/modal';
import { shipmentDocTypes } from 'config/documents';
import { upsertStopDocumentsConfig } from 'utils/UserServiceAPIUtils';
import { showToast } from 'stores/ToastStore';
import Spinner from 'components/ui/Spinner';
import MultiSelectTable from 'components/v2/MultiSelectTable';
export default function EditShipperRulesModal({ currentMovement, currentStop, onHide, id, }) {
    const { t } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [requiredDocs, setRequiredDocs] = useState([]);
    useEffect(() => {
        setRequiredDocs(((currentStop === null || currentStop === void 0 ? void 0 : currentStop.docTypes) || []).map((doc) => {
            return { name: t(doc === null || doc === void 0 ? void 0 : doc.toUpperCase()), value: doc };
        }));
    }, []);
    const SHIPMENT_DOCS_MAPPED = shipmentDocTypes.map((doc) => {
        return {
            name: t(doc.localizationSlug),
            value: doc.value,
        };
    });
    const handleSave = async () => {
        var _a, _b;
        const shipperId = id;
        try {
            const movementType = (_a = currentMovement.split('_')[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
            const shipmentType = (_b = currentMovement.split('_')[1]) === null || _b === void 0 ? void 0 : _b.toUpperCase();
            const empty = currentStop.name.includes('EMPTY');
            const offsite = currentStop.name.includes('OFFSITE');
            const actionType = currentStop.name.includes('PICKUP')
                ? 'PICKUP'
                : 'DELIVER';
            const stopDocuments = requiredDocs.map((doc) => doc.value);
            const stopConfigurations = [
                {
                    movementType,
                    shipmentType,
                    empty,
                    offsite,
                    actionType,
                    stopDocuments,
                },
            ];
            const response = await upsertStopDocumentsConfig(shipperId, stopConfigurations);
            if (!response) {
                throw new Error('No response from API');
            }
            showToast(t('EDIT_STOP_DOC_SUCCESS'));
        }
        catch (e) {
            console.error('Error during upsertStopDocumentsConfig: ', e.message);
            showToast(t('EDIT_STOP_DOC_FAILURE'), null, 'error');
        }
    };
    const handleClickSave = async () => {
        setIsSaving(true);
        setIsDisabled(true);
        await handleSave();
        onHide();
    };
    const renderSpinner = () => {
        return React.createElement(Spinner, { showMessage: true, message: t('SAVING') });
    };
    const editShipperRulesBody = () => {
        return (React.createElement(MultiSelectTable, { selectedColumnName: t('REQUIRED_DOCUMENTS'), availableColumnName: t('AVAILABLE_DOCUMENTS'), columnNamesClassName: "block text-sm font-medium text-gray-700 font-semibold text-nowrap", selectedItems: requiredDocs, allItemsList: SHIPMENT_DOCS_MAPPED, onSelect: setRequiredDocs }));
    };
    const editShipperRulesFooter = () => {
        return (React.createElement("div", null,
            React.createElement(Button, { className: "m-1", color: "green", type: "button", disabled: isDisabled, onClick: () => {
                    handleClickSave();
                } }, isSaving ? renderSpinner() : t('SAVE')),
            React.createElement(Button, { className: "m-1", type: "button", onClick: () => {
                    onHide();
                } }, t('CANCEL'))));
    };
    return (React.createElement(CargomaticModal, { title: `${t(currentMovement)} ${t(currentStop.name)}`, onHide: onHide, body: editShipperRulesBody(), footer: editShipperRulesFooter() }));
}
